import { render, staticRenderFns } from "./open-evaluations.vue?vue&type=template&id=b7386ec6&"
import script from "./open-evaluations.js?vue&type=script&lang=js&"
export * from "./open-evaluations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports